import angular from 'angular';

const kformScopeFactory = /* @ngInject */ (
	/** @type {any} */ KformComponents,
	/** @type {import('angular').ITimeoutService} */ $timeout,
) => ({
	/**
	 * @param {any} $scope
	 * @param {any} $element
	 * @returns {Function}
	 */
	onError($scope, $element) {
		return (/** @type {any} */ error) => {
			if ((error.name === 'ValidationError') && $element) {
				const element = $element.find(`#form-group-${error.details[0].path}`);
				element.addClass('has-error');
				const message = `ValidationError: ${ error.details[0].message}`;
				$scope.showAlerts({
					type: 'danger',
					message,
				});
				$scope.$on('formSubmit', () => {
					element.removeClass('has-error');
				});
			}
			else {
				if (error instanceof Error) {
					// eslint-disable-next-line no-param-reassign
					error = error.toString();
				}
				else if (typeof error === 'object') {
					// eslint-disable-next-line no-param-reassign
					error = JSON.stringify(error);
				}
				$scope.showAlerts({
					type: 'danger',
					message: error,
				});
			}
			$scope.$emit('formError', error);
		};
	},
	/**
	 * @param {any} $scope
	 * @returns {any}
	 */
	register($scope) {
		let loader = null;
		$scope.formLoading = true;
		$scope.form = angular.isDefined($scope.form) ? $scope.form : {};
		$scope.submission = angular.isDefined($scope.submission) ? $scope.submission : { data: {} };
		$scope.submissions = angular.isDefined($scope.submissions) ? $scope.submissions : [];

		// Keep track of the elements rendered.
		let elementsRendered = 0;
		$scope.$on('formElementRender', () => {
			elementsRendered++;
			if (elementsRendered === $scope.form.components.length) {
				$timeout(() => {
					$scope.$emit('formRender', $scope.form);
				});
			}
		});

		$scope.setLoading = (/** @type {any} */ _loading) => {
			$scope.formLoading = _loading;
		};

		// Allow sub components the ability to add new form components to the form.
		/** @type {any} */
		const addedData = {};
		$scope.$on('addFormComponent', (/** @type {any} */ event, /** @type {any} */ component) => {
			if (!Object.prototype.hasOwnProperty.call(addedData, component.settings.key)) {
				addedData[component.settings.key] = true;
				const defaultComponent = KformComponents.components[component.type];
				$scope.form.components.push(angular.extend(defaultComponent.settings, component.settings));
			}
		});

		// Trigger a form load event when the components length is more than 0.
		$scope.$watch('form.components.length', () => {
			if (
				!$scope.form
					|| !$scope.form.components
					|| $scope.form.components.length === 0
			) {
				return;
			}
			$scope.setLoading(false);
			$scope.$emit('formLoad', $scope.form);
		});

		$scope.updateSubmissions = () => {
			$scope.setLoading(true);
			const parameters = {};
			if ($scope.perPage) {
				parameters.limit = $scope.perPage;
			}
			if ($scope.skip) {
				parameters.skip = $scope.skip;
			}
		};
		$scope.updateSubmissions.bind(this);

		loader = {};

		$scope.formoLoaded = true;
		$scope.formLoading = !$scope.form || (Object.keys($scope.form).length === 0)
				|| $scope.form.components.length === 0;
		$scope.setLoading($scope.formLoading);

		// Emit the events if these objects are already loaded.
		if (!$scope.formLoading) {
			$scope.$emit('formLoad', $scope.form);
		}
		if ($scope.submission) {
			$scope.$emit('submissionLoad', $scope.submission);
		}
		if ($scope.submissions) {
			$scope.$emit('submissionsLoad', $scope.submissions);
		}

		// Return the loader.
		return loader;
	},
});

export default kformScopeFactory;
